<template>
  <div class="member-integral-record clear">
    <TabsSimple :tabs="tabs" :value.sync="curTab" @on-change="onChangeTab"></TabsSimple>
    <div class="table">
      <div class="thead tr">
        <div class="td" v-for="(item, index) in tableColumns" :key="index" :style="item.style">
          {{ item.label }}
        </div>
      </div>
      <empty v-if="!list.length" :img-width="130" :tb-padding="30"></empty>
      <div class="tbody">
        <div class="tr" v-for="(rowItem, index) in list" :key="index">
          <div
            class="td"
            v-for="(colItem, index) in tableColumns"
            :key="index"
            :class="colItem.key"
            :style="colItem.style"
          >
            <template v-if="colItem.key == 'name'">
              <div class="img-wrap" :class="rowItem.shop_type == 12 ? 'book' : 'course'">
                <img class="cover" :src="rowItem.cover_img" alt />
              </div>
              <div class="text-wrap" :class="rowItem.shop_type == 12 ? 'book' : 'course'">
                <p>{{ rowItem.product_name }}</p>
                <p class="valid-wrap" v-if="rowItem.shop_type != 12">
                  <template v-if="rowItem.valid_type == 1">长期有效</template>
                  <template v-else-if="rowItem.valid_type == 2">
                    {{ rowItem.valid_end_time | tsFormatDate }}到期 (截止日期：{{
                      rowItem.valid_end_time | tsFormatDate
                    }})
                  </template>
                  <template v-else-if="rowItem.valid_type == 3">
                    {{ rowItem.valid_end_time | tsFormatDate }}到期 (按有效天数：{{
                      rowItem.valid_time
                    }}天)
                  </template>
                </p>
              </div>
            </template>
            <template v-else-if="colItem.key == 'point'">
              {{ rowItem.product_price }}
            </template>
            <template v-else-if="colItem.key == 'status'">
              {{ getStatusName(rowItem) }}
            </template>
            <template v-else-if="colItem.key == 'time'">
              {{ rowItem.created_at | tsFormat('yyyy/MM/dd hh:mm:ss') }}
            </template>
            <template v-else-if="colItem.key == 'action'">
              <div v-if="rowItem.is_virtual == 2">
                <div class="btn-box" v-if="rowItem.order_status != 2 && rowItem.ship_status == 3">
                  <p class="btn" @click="onLogisticsDetail(rowItem)">物流信息</p>
                  <p class="btn primary" @click="onConfirmShip(rowItem)">确认收货</p>
                </div>
                <p v-else>--</p>
              </div>
              <div v-else>--</div>
            </template>
          </div>
        </div>
      </div>
      <el-pagination
        background
        @current-change="onCurrentChange"
        :current-page="page"
        :page-size="limit"
        layout="prev, pager, next, total, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      class="logistice-dlg"
      title="物流信息"
      :visible.sync="dlgLogistics.show"
      width="400px"
      center
    >
      <div class="dlg-content">
        <p>
          <span class="dlg-content-label">快递公司：</span>
          <span>{{ dlgLogistics.logistics_name }}</span>
        </p>
        <p>
          <span class="dlg-content-label">快递单号：</span>
          <span>{{ dlgLogistics.logistics_number }}</span>
        </p>
      </div>
      <div slot="footer" class="dlg-btn-wrap">
        <el-button @click="dlgLogistics.show = false" size="small" round> 取消 </el-button>
        <el-button class="btn-comfirm" type="primary" @click="onCopyLogistics" size="small" round>
          复制单号
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="确认收货" :visible.sync="dlgComfirmShip.show" width="400px" center>
      <div class="dlg-content">
        <p>确认收货后，订单将会完成，是否确认？</p>
      </div>
      <div slot="footer" class="dlg-btn-wrap">
        <el-button @click="dlgComfirmShip.show = false" size="small" round> 取消 </el-button>
        <el-button type="primary" @click="onOkConfirmShip" size="small" round> 确认 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Empty from '@/components/Empty';
import ClipboardJS from 'clipboard';
export default {
  name: 'member-integral-record',
  components: {
    Empty,
  },
  data() {
    return {
      tabs: [
        { label: '全部', name: 0 },
        { label: '待发货', name: 1 },
        { label: '已发货', name: 2 },
        { label: '已完成', name: 3 },
      ],
      curTab: 0,
      list: [],
      page: 1,
      limit: 10,
      total: 0,
      dlgLogistics: {
        show: false,
        logistics_name: '',
        logistics_number: '',
      },
      dlgComfirmShip: {
        show: false,
        order_id: 0,
      },
    };
  },
  computed: {
    tableColumns() {
      return [
        {
          label: '商品名称',
          key: 'name',
          style: { textAlign: 'left', width: 'auto', flexGrow: 1 },
        },
        {
          label: `单价（${this.$store.state.commonSetting.point_info.point_name || ''}）`,
          key: 'point',
          style: {
            width: '110px',
          },
        },
        { label: '订单状态', key: 'status', style: { width: '100px' } },
        {
          label: '兑换时间',
          key: 'time',
          style: { width: '116px', wordBreak: 'break-word' },
        },
        { label: '操作', key: 'action', style: { width: '120px' } },
      ];
    },
  },
  created() {
    this.requestList();
  },
  mounted() {
    this.initClipbord();
  },
  methods: {
    // on event
    onChangeTab() {
      this.page = 1;
      this.requestList();
    },
    onLogisticsDetail(item) {
      this.dlgLogistics.show = true;
      this.dlgLogistics.logistics_name = item.logistics_name;
      this.dlgLogistics.logistics_number = item.logistics_number;
    },
    onConfirmShip(item) {
      this.dlgComfirmShip.show = true;
      this.dlgComfirmShip.order_id = item.order_id;
    },
    onCopyLogistics() {
      this.$success('复制成功');
      this.dlgLogistics.show = false;
    },
    onOkConfirmShip() {
      this.$http.put(`/api/app/orderShip/confirm/${this.dlgComfirmShip.order_id}`).then(() => {
        this.dlgComfirmShip.show = false;
        this.requestList();
      });
    },
    onCurrentChange(val) {
      this.page = val;
      this.requestList();
    },
    // other
    initClipbord() {
      const that = this;
      // eslint-disable-next-line no-new
      new ClipboardJS('.logistice-dlg .btn-comfirm', {
        text: function () {
          return that.dlgLogistics.logistics_number || ' ';
        },
      });
    },
    getStatusName(item) {
      if (item.order_status == 2) {
        return '已完成';
      }
      if (item.is_virtual == 2) {
        switch (item.ship_status) {
          case 1:
            return '待发货';
          case 3:
            return '已发货';
        }
      }
      return '';
    },
    // request
    requestList() {
      this.$http
        .get('/api/app/user/integral/order', {
          status: this.curTab,
          page: this.page,
          limit: this.limit,
        })
        .then((data) => {
          this.list = data.list;
          this.total = data.total;
          this.list.forEach((i) => {
            i.product_price = (i.product_price / 100).toFixed(0);
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.member-integral-record {
  .tabs-simple {
    margin-bottom: 20px;
  }
  .table {
    .thead {
      height: 36px;
      line-height: 36px;
      background-color: #f7f7f7;
      border-radius: 3px;
      font-size: 14px;
      color: #666;
      margin-bottom: 20px;
      .td {
        padding: 0 15px;
        white-space: nowrap;
      }
    }
    .tr {
      display: flex;
      justify-content: space-between;
    }
    .td {
      text-align: center;
      width: 100%;
      box-sizing: border-box;
    }
    .tbody {
      font-size: 14px;
      color: #343434;
      .tr {
        border: 1px solid #f5f5f5;
        margin-bottom: 20px;
        border-radius: 3px;
      }
      .td {
        display: flex;
        padding: 15px;
        justify-content: center;
        align-items: center;
        min-height: 116px;
        border-right: 1px solid #f5f5f5;
        &:last-child {
          border-right: none;
        }
      }
    }
    .td.name {
      justify-content: flex-start;
      .img-wrap {
        width: 100px;
        margin-right: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.book .cover {
          width: 60px;
          height: 80px;
        }
        &.course .cover {
          width: 96px;
          height: 64px;
        }
        .cover {
          border-radius: 10px;
          box-shadow: 0 0 26px 0 rgba(0, 0, 0, 0.2);
        }
      }
      .text-wrap {
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
        &.course {
          padding: 5px 0;
        }
        .valid-wrap {
          color: #9a9a9a;
        }
      }
    }
    .td.point {
      color: #e02020;
    }
    .td.time {
      color: #9a9a9a;
    }
    .td.action {
      flex-direction: column;
      .btn {
        color: #595959;
        font-size: 15px;
        display: inline-block;
        border: 1px solid #d9d9d9;
        border-radius: 14px;
        height: 28px;
        line-height: 28px;
        padding: 0 10px;
        margin-bottom: 15px;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
        &.primary {
          color: $primary-color;
          border: 1px solid $primary-color;
        }
      }
    }
  }
  .dlg-btn-wrap {
    .el-button {
      min-width: 130px;
      margin: 0 15px;
    }
  }
  .dlg-content {
    text-align: center;
    font-size: 14px;
    .dlg-content-label {
      color: #b7b7b7;
    }
  }
}
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
</style>
